module.exports = __webpack_public_path__ + "mobile.2bce8e93.png";